import decodeUrl, { IS3Image } from './decodeUrl';
import getImageUrl from './getImageUrl';
import getKey from './getKey';
import parseImageUri from './parseImageUri';
import parseS3Uri from './parseS3Uri';
export interface IS3 {
  getImageUrl: (key: string, target: object, bucket?: string) => Promise<{ url: string }>;
  decodeUrl: (item: IS3Image) => Promise<IS3Image>;
  getKey(location: string): string;
  parseS3Uri(uri: string): { bucket: string; key: string };
  parseImageUri(uri: string): { bucket: string; key: string };
}

const S3: IS3 = {
  getImageUrl,
  decodeUrl,
  getKey,
  parseS3Uri,
  parseImageUri
}

export default S3;
